import { signOut } from 'firebase/auth'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../utitilties/firebase'
import './navbar.css'
import Logo from '../../assets/icons/logo.png'

const NavBar = () => {

    const navigate = useNavigate()



    return (
        <div className='navbar' >

            <div onClick={()=>navigate('/')}  style={{ display: 'flex', cursor: 'pointer' }} >
                <img src={Logo} className='logo' />
                <h1>orebro</h1>
            </div>

            <div style={{ flex: 1 }} />


            {auth?.currentUser?.email && <div className="btn"
                onClick={() => navigate('/add_physio')}
            >
                <p>Add</p>
            </div>
            }

            {auth?.currentUser?.email && <div className="btn"
                style={{ marginLeft: 10 }}
                onClick={() => { signOut(auth); navigate('/login') }}
            >
                <p>Logout</p>
            </div>}
        </div>
    )
}

export default NavBar